import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/site';

const catName = (id: string) => categories.find((c) => c.id === id)?.name ?? '专题';
const topicTitle = (id: string) => topics.find((t) => t.id === id)?.title ?? '专题';

export default function HotAndLatest() {
  const ranked = [...topics].sort((a, b) => b.hotScore - a.hotScore).slice(0, 6);
  const latest = [...articles]
    .sort((a, b) => (a.publishTime < b.publishTime ? 1 : -1))
    .slice(0, 6);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className="ri-fire-line text-lg" />
              </span>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">专题热度榜</h2>
            </div>
            <ol className="flex flex-col">
              {ranked.map((t, idx) => (
                <li key={t.id}>
                  <Link
                    to={`/topic/${t.id}`}
                    className="group flex items-start gap-4 py-4 border-b border-background-200 hover:border-primary-300 transition-colors"
                  >
                    <span
                      className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-md text-sm font-bold ${
                        idx < 3
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-200 text-foreground-700'
                      }`}
                    >
                      {idx + 1}
                    </span>
                    <span className="flex-1 min-w-0">
                      <span className="block text-sm font-medium text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {t.title}
                      </span>
                      <span className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500">
                        <span>{catName(t.categoryId)}</span>
                        <span className="flex items-center gap-1">
                          <i className="ri-fire-line text-primary-500" />
                          {t.hotScore}
                        </span>
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </div>

          <div className="lg:col-span-3">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className="ri-time-line text-lg" />
                </span>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">最新更新</h2>
              </div>
              <Link
                to="/library"
                className="text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap transition-colors"
              >
                查看全部
              </Link>
            </div>
            <div className="flex flex-col gap-3">
              {latest.map((a) => (
                <Link
                  key={a.id}
                  to={`/article/${a.id}`}
                  className="group flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-5 p-4 rounded-lg border border-background-200 bg-background-50 hover:border-accent-400 transition-colors"
                >
                  <span className="text-xs text-primary-600 bg-primary-50 px-2.5 py-1 rounded-md w-fit whitespace-nowrap">
                    {a.publishTime}
                  </span>
                  <span className="flex-1 min-w-0">
                    <span className="block text-sm font-medium text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
                      {a.title}
                    </span>
                    <span className="block mt-1 text-xs text-foreground-500 line-clamp-1">
                      所属专题：{topicTitle(a.topicId)}
                    </span>
                  </span>
                  <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-600 transition-colors hidden sm:block" />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}